<template>
  <div class="page" style="margin-top: 40px;">
    <div class="tips-warn">
      <span>温馨提示：</span>
      为了给您提供更好的域名转入体验，0元以及使用优惠券转入的域名，系统将默认不再发送确认转入邮件，请知悉!
    </div>
    <div class="bj-ce">
      <div :class="['ce', {active: form.transferinType == 0 }]" @click="check(0)">单个转入</div>
      <div :class="['ce', {active: form.transferinType == 1 }]" style="margin-left: 40px;" @click="check(1)">批量转入</div>
    </div>
    <div class="content">
      <Form style="margin-top: 20px">
        <FormItem
          v-show="form.transferinType === 0"
          class="cc-form-item"
          :label="'转入的域名(' + dnNumber + ')'"
          required
        >
          <Input
            class="bj-input-26262A bj-input-h45"
            style="width: 430px"
            v-model="form.domainName"
            placeholder="请输入转入的域名"
            @on-keyup="getDNNumber"
            @on-blur="getAvailableDN"
            clearable
          ></Input>
        </FormItem>
        <FormItem
          :key="form.transferinType"
          v-show="form.transferinType === 1"
          class="cc-form-item"
          :label="'转入的域名(' + dnNumber2 + ')'"
          required
        >
          <Input
            class="bj-input-26262A"
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 500 }"
            style="width: 500px"
            v-model="form.domainNameMore"
            placeholder="请输入转入的域名(如123.com,123456)"
            @on-keyup="getDNNumber2"
            @on-blur="getAvailableDN2"
            clearable
          ></Input>
        </FormItem>
        <FormItem
          v-show="form.transferinType === 0"
          class="cc-form-item"
          label="转移码"
          required
        >
          <Input
            class="bj-input-26262A bj-input-h45"
            style="width: 430px"
            v-model="form.domainCode"
            placeholder="请输入转移码"
            clearable
          ></Input>
        </FormItem>
        <FormItem
          class="cc-form-item"
          label="DNS设置"
          required
        >
          <RadioGroup v-model="form.dnsType">
            <Radio class="bj-color-F85A36" :label="0"> 原DNS</Radio>
            <Radio class="bj-color-F85A36" :label="1"> 我司DNS</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div class="bj-rows">
        <Checkbox class="bj-color-F85A36" v-model="single"> 我已同意并阅读</Checkbox>
        <span style="color: #F85A36; cursor: pointer" @click="transferRulesModel">《域名转移服务协议》</span>
      </div>
      <div style="margin-top: 40px;text-align: center;">
        <Button :loading="loading" type="primary" class="bj-w120 bj-h45 bj-confirm-btn" @click="submit()">提交转入</Button>
      </div>
    </div>
    <!-- 转入结果 -->
    <transferinListModal
      :show.sync="transferistModalVisibility"
      :data="resultList"
    ></transferinListModal>
    <!-- 域名转移服务协议 -->
    <rule-modal
      :show.sync="transferRulesModelShow"
      :content="transferRulesContent"
      :title="transferRulesTitle"
    ></rule-modal>
  </div>
</template>

<script>
import { transferIntoSave } from "api/domain.js";
import { debounce, trimStr } from "utils/index";
import transferinListModal from "components/transferin/transferinListModal.vue";
import ruleModal from "components/ruleModal.vue";
import transferRules from "assets/rule/transferRules";
export default {
  name: "transferin",
  components: {
    transferinListModal,
    ruleModal,
  },
  data() {
    return {
      form: {
        transferinType: 0,
        domainNameMore: "",
        domainName: "",
        domainCode: "",
        dnsType: 0,
      },
      loading: false,
      dnNumber: 0,
      dnNumber2: 0,
      single: false,
      resultList: [],
      transferistModalVisibility: false,
      // 域名转移服务协议
      transferRulesModelShow: false,
      transferRulesContent: "",
      transferRulesTitle: "",
    };
  },
  methods: {
    // 域名管理系统域名push服务协议
    transferRulesModel() {
      this.transferRulesModelShow = true;
      if (!this.transferRulesContent) {
        this.transferRulesContent = transferRules.content;
        this.transferRulesTitle = transferRules.title;
      }
    },
    // 函数防抖获取输入框中的域名
    getDNNumber: debounce(function () {
      const temp = this.form.domainName.split("\n");
      this.dnNumber = temp.filter((item) => {
        return !item.match(/^[ ]*$/);
      }).length;
    }, 200),
    // 筛选出有用域名
    getAvailableDN() {
      const temp = this.form.domainName.split("\n").filter((item) => {
        return !item.match(/^[ ]*$/);
      });
      const dnList = temp.map((item) => trimStr(item));
      this.dnSet = new Set(dnList);
      this.form.domainName = [...this.dnSet].join("\n");
      this.dnNumber = this.dnSet.size;
    },
    // 函数防抖获取输入框中的域名
    getDNNumber2: debounce(function () {
      const temp = this.form.domainNameMore.split("\n");
      this.dnNumber2 = temp.filter((item) => {
        return !item.match(/^[ ]*$/);
      }).length;
    }, 200),
    // 筛选出有用域名
    getAvailableDN2() {
      const temp = this.form.domainNameMore.split("\n").filter((item) => {
        return !item.match(/^[ ]*$/);
      });
      const dnList = temp.map((item) => trimStr(item));
      this.dnSet2 = new Set(dnList);
      this.form.domainNameMore = [...this.dnSet2].join("\n");
      this.dnNumber2 = this.dnSet2.size;
    },
    async submit() {
      try {
        let transferData = [];
        if (this.form.transferinType === 0) {
          if (!this.form.domainName) {
            this.$Message.warning("请输入域名！");
            return false;
          }
          if (!this.form.domainCode) {
            this.$Message.warning("请输入转移码！");
            return false;
          }
          transferData[0] = `${this.form.domainName},${this.form.domainCode}`;
        } else {
          const list = [...this.dnSet2];
          if (list.length <= 0) {
            this.$Message.warning("请至少输入一个域名");
            return;
          }
          transferData = list;
        }
        if (!this.single) {
          this.$Message.warning(`请阅读并同意《域名转移服务协议》！`);
          return;
        }

        const params = {
          type: this.form.dnsType,
          ymList: transferData,
        };
        const { code, data, result } = await transferIntoSave(params);
        if (code === 200 && result) {
          if (data.length === 0) {
            this.$Message.success("已加入购物车");
            setTimeout(() => {
              window.location.href = '/cart'
            }, 2000)
          } else {
            this.resultList = data;
            this.transferistModalVisibility = true;
          }
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    check(type){
      this.form.transferinType = type;
    }
  },
};
</script>

<style lang="less" scoped>
.tips-warn{
  display: flex;
  justify-content: flex-start;
  background-color: #38393B;
  color: #fff;
  line-height: 46px;
  padding: 0 24px;
  border-radius: 6px;
  margin-bottom: 30px;
}
.content{
  background-color: #2C2E2F;
  border-radius: 6px;
  padding: 40px;
  color: #fff;
}
.bj-ce{
  display: flex;
  align-items: center;
  .ce{
    width: 200px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    background-color: #2C2D30;
    color: #fff;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    cursor: pointer;
    transition: all .3s;
  }
  .ce.active{
    background-color: #77382C;
  }
}
::v-deep .ivu-form-item-label{
  min-width: 160px;
  text-align: right;
  color: #fff;
}
</style>
